<template>
  <footer class="footer" :class="{ 'no-margins': isAccountPage }">
    <div class="footer-inner">
      <logo-image class="footer-logo"/>
      <div class="mt10 mobile">
        <div class="pointer mr10" :class="{'active-lan': activeLen === 'uk'}" @click="changesLan('uk-UA')">УКР</div> |
        <div class="pointer ml10" :class="{'active-lan': activeLen === 'en'}" @click="changesLan('en-US')">EN</div>
      </div>
      <nav class="footer-menu">
        <ul>
          <li class="footer-menu-item">
            <router-link class="footer-menu-item-link"
                         :to="{ name: 'about-us' }"
            > {{ $t('About us') }} </router-link>
          </li>
          <li class="footer-menu-item">
            <router-link class="footer-menu-item-link"
                         :to="{ name: 'contacts' }"
            > {{ $t('Contacts') }} </router-link>
          </li>
          <li class="footer-menu-item">
            <router-link class="footer-menu-item-link"
                         :to="{ name: 'umovi-dostavki' }"
            > {{ $t('Delivery and payment') }} </router-link>
          </li>
          <li class="footer-menu-item">
            <router-link class="footer-menu-item-link"
                         :to="{ name: 'terms-of-use' }"
            > {{ $t('Terms of use') }} </router-link>
          </li>
          <li class="footer-menu-item">
            <router-link class="footer-menu-item-link"
                         :to="{ name: 'privacy' }"
            > {{ $t('Privacy') }} </router-link>
          </li>
          <li class="footer-menu-item">
            <router-link class="footer-menu-item-link"
                         :to="{ name: 'FAQ' }"
            > {{ $t('FAQ') }} </router-link>
          </li>
          <li class="footer-menu-item">
            <router-link class="footer-menu-item-link"
                         :to="{ name: 'vacancies' }"
            > {{ $t('Vacancies') }} </router-link>
          </li>
        </ul>
      </nav>
      <div class="footer-icons">
        <nav class="footer-icons-menu">
          <a href="https://www.facebook.com/korzynacom/" class="footer-icons-menu-item no-underline">
            <img src="/assets/icons/icon-fb.svg" alt="facebook" width="20" height="20" loading="lazy" fetchpriority="auto">
          </a>
          <a href="https://instagram.com/korzynacom?igshid=snwc0cizpxln" class="footer-icons-menu-item no-underline">
            <img src="/assets/icons/icon-inst.svg" alt="instagram" width="20" height="20" loading="lazy" fetchpriority="auto">
          </a>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script async>
import { mapGetters } from 'vuex'
import LogoImage from '../../../core/LogoImage.vue';

export default {
  name: 'AdditionalFooter',
  components: {
    LogoImage
  },
  data () {
    return {
      detailsOpen: false
    }
  },
  methods: {
    changesLan (ln) {
      this.$store.dispatch('languages/changesCurrenLanguage', ln);
    }
  },
  computed: {
    ...mapGetters({
      stores: 'partners/getPartners',
      currentPartner: 'partners/getCurrentPartner'
    }),
    isAccountPage () {
      let links = ['my-order', 'my-orders', 'my-account', 'my-shipping-details', 'my-payment-details']
      return links.includes(this.$route.name)
    },
    activeLen () {
      return this.$root.$i18n.locale === 'en-US' ? 'en' : 'uk'
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;

  margin-top: 40px;
  padding: 20px 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  flex: 0 0 auto;

  background: #f9f8f6;

  &.no-margins {
    margin-top: 0;
  }

  &-inner {
    width: 1154px;
    padding: 0 15px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    @media only screen and (max-width: 1154px) {
      width: 100%;

      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  &-logo {

    & img {
      width: 150px;
      height: 33px;
    }
  }

  &-menu {
    @media only screen and (max-width: 1154px) {
      margin: 10px 0 20px 0;
    }

    & ul {
      margin: 0;
      padding: 0;
      list-style: none;

      display: flex;
      justify-content: center;

      @media only screen and (max-width: 1154px) {
        width: 100%;

        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }

    &-item {
      margin: 0 10px;

      @media only screen and (max-width: 1154px) {
        margin: 0 10px 12px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }

      &-link {
        width: 100%;

        position: relative;
        display: inline-flex;

        font-size: 14px;

        &:hover {
          text-decoration: underline;
        }

        @media only screen and (max-width: 1154px) {
          font-size: 16px;
        }
      }
    }
  }

  &-icons {
    height: 100%;
    display: flex;

    &-menu {
      display: flex;

      & ul {
        margin: 0;
        list-style: none;

        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      &-item {
        width: 40px;
        height: 40px;

        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 50%;
        box-shadow: 0 0 8px -1px rgba(0, 0, 0, .1);

        & + & {
          margin-left: 10px;
        }

        & img {
          width: 22px;
          height: 22px;
        }
      }
    }
  }
  .active-lan {
    color: #11bb2e;
    background: #f9f8f6;
  }
  .mobile {
    display: none;
    @media (max-width: 576px) {
      display: flex;
    }
  }
}
</style>
